import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface ProjectDescriptionFieldProps {
  description: string;
  setDescription: (value: string) => void;
}

const ProjectDescriptionField: React.FC<ProjectDescriptionFieldProps> = ({ description, setDescription }) => {
  return (
    <div>
      <Label htmlFor="description">
        Description
      </Label>
      <Textarea
        id="description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Enter goal description"
        className="min-h-[100px]"
      />
    </div>
  );
};

export default ProjectDescriptionField;
